import { ThemeProp } from '@trarc/pc-shared';
import styled from 'styled-components';

interface StyledSideBarProps {
  $isExpanded?: boolean;
}

export const PageGroupContainer = styled.div<StyledSideBarProps>`
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  background: ${(props: ThemeProp) => props.theme.colors.white};
  gap: 0.5rem;
  overflow-y: auto;
  overflow-x: hidden;
`;
